import React, { forwardRef, memo } from 'react';
import { Map, TileLayer, ZoomControl, Polyline } from 'react-leaflet';

import sameDataLength from '../../util/sameDataLength';
import leafletClickListener from '../MaoKunMap/leafletClickListener';
import toLatLngObject from '../../util/toLatLngObject';
import LabeledMarker from './LabeledMarker';
import './ModernMap.css';

const outlinksDisabled = document.location.pathname === '/nls';
const TILE_SOURCE = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
const TILE_ATTRIBUTION =
  '&copy; <a href="https://carto.com/attributions">CARTO</a> &copy; <a href="http://openstreetmap.org">OSM</a>';

const hasKnownLocation = (f) =>
  (f.geometry.type === 'Point' && f.geometry.coordinates[0]) ||
  (f.geometry.type === 'LineString' && f.properties.code.length && f.geometry.coordinates);

const ModernMap = forwardRef((props, ref) => {
  return (
    <section className="modern">
      <Map
        ref={ref}
        center={[11.25, 75.75]}
        zoom={3}
        zoomControl={false}
        attributionControl={!outlinksDisabled}
        onClick={leafletClickListener(props.onSelect, props.onClick)}
        onMove={props.onViewChange}
        onZoomend={props.onViewChange}
      >
        <TileLayer attribution={TILE_ATTRIBUTION} url={TILE_SOURCE} prefix={false} maxZoom={20} />
        <ZoomControl position="bottomright" />
        {props.places.filter(hasKnownLocation).map((f) => (
          <LabeledMarker key={f.properties.id} labeled={props.labelLocations} onSelect={props.onSelect} {...f} />
        ))}

        {props.paths.filter(hasKnownLocation).map(({ properties, geometry }) => (
          <Polyline
            key={properties.code}
            positions={geometry.coordinates.map(toLatLngObject)}
            onClick={() => props.onSelect(properties.code, 'path', 'modern')}
            className={`path ${properties.direction} code-${properties.code}`}
          />
        ))}
      </Map>
    </section>
  );
});

export default memo(ModernMap, sameDataLength);
